import { Fragment } from 'react';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import useAthleteUserEntriesDetail from './UseAthleteUserEntriesDetail';

import AthleteUserEntriesDetailGrid from './AthleteUserEntriesDetailGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserEntriesDetail = () => {
  const { athleteEntryContextState, onNextButtonClicked, onSaveAndExitButtonClicked, errorState,
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, orgUnitAthleteEntryIndividualRosterEntryState, onBackButtonClicked,
    orgUnitAthleteEntryInfoState, omeMeetOrgUnitEntryTimesState, state, gridState, athleteMeetEventState,
    onAddEventClicked, onAddBonusEventClicked, onDeleteEventClicked, onDeleteEvent, modalState, onModalCanceled, onUpdateAthleteTimes
  } = useAthleteUserEntriesDetail();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_ROSTER_ENTRIES_DETAIL}
        onNextButtonClicked={onNextButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        errorMessage={errorState.general} >
        <div className={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.status === 'Relay Only Swimmer' ? global.HideComponent : global.DisplayComponent}>
          {athleteEntryContextState.isReadOnly === false ?
            <Fragment>
              <div className="row">
                <div className="col-xs-12">
                  <ActionIntraPageButton onClick={onAddEventClicked}>Select Events</ActionIntraPageButton>
                  {state.bonusEvents === true && <Fragment>&nbsp;<ActionIntraPageButton onClick={onAddBonusEventClicked}>Select Bonus Events</ActionIntraPageButton></Fragment>}
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <AthleteUserEntriesDetailGrid
                    gridData={gridState.gridData}
                    isLoading={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading}
                    onDeleteEventClicked={onDeleteEventClicked}
                    showStatusColumn={athleteEntryContextState.isUnattached === false && orgUnitAthleteEntryInfoState?.objData?.orgUnitAthleteRegistrationAllowed === true ? true : false}
                  />
                </div>
              </div>
              {gridState.gridData.length > 0 && gridState.showUpdateButton === true &&
                <div className="row">
                  <div className={style.FloatRight}>
                    <div className="col-xs-12 usas-extra-top-margin">
                      <PrimaryButton onClick={(e) => onUpdateAthleteTimes(e)}>Update Individual Event Entry Times</PrimaryButton>
                    </div>
                  </div>
                </div>}
              <PopUpModal
                widthPct={90}
                maxWidth={720}
                title={modalState.modalTitle}
                displayPopUp={modalState.displayPopUp}
                onModalCanceled={onModalCanceled}>
                <div className="row">
                  <div className="col-xs-12">
                    <p><strong>Athlete:</strong> {modalState.athlete}</p>
                    <p><strong>Event:</strong> {modalState.eventName}</p>
                    <p><strong>Competition Category:</strong> {modalState.eventCompetitionGenderTypeName}</p>
                    <p><strong>Age Group:</strong> {modalState.ageGroupName}</p>
                    <p><strong>Session:</strong> {modalState.meetSessionName}</p>
                    {athleteEntryContextState.isUnattached === false && orgUnitAthleteEntryInfoState?.objData?.orgUnitAthleteRegistrationAllowed === true && <p><strong>Status:</strong> {modalState.status}</p>}
                    <p><strong>Entry Time:</strong> {modalState.entryTime || 'NT'} {modalState?.qualifyingCourseCode}</p>
                    <p><strong>Time Event:</strong> {modalState.timeEvent || ''}</p>
                    <p><strong>Bonus Entry:</strong> {modalState.qualifiedAsBonus}</p>
                    <p><strong>Override Entry:</strong> {modalState.override}</p>
                  </div>
                  <div className="col-xs-12 usas-extra-top-margin">
                    <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                    <PrimaryButton type="button" onClick={(e) => onDeleteEvent(e, modalState.individualAthleteMeetEventId)}>Delete</PrimaryButton>
                  </div>
                </div>
              </PopUpModal>
              <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading ||
                  omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading || omeMeetOrgUnitEntryTimesState.isSaving ||
                  orgUnitAthleteEntryInfoState.isObjLoading || orgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading} />
              <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.SAVING_MSG}
                displayPopUp={athleteMeetEventState.isSaving} />
            </Fragment> :
            <Fragment>
              <div className="row">
                <div className="col-xs-12">
                  <AthleteUserEntriesDetailGrid
                    gridData={gridState.gridData}
                    isLoading={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading}
                    showStatusColumn={athleteEntryContextState.isUnattached === false && orgUnitAthleteEntryInfoState?.objData?.orgUnitAthleteRegistrationAllowed === true ? true : false}
                  />
                </div>
              </div>
              <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading ||
                  omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading ||
                  orgUnitAthleteEntryInfoState.isObjLoading || orgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading} />
            </Fragment>
          }
        </div>
      </ViewTemplate>
    </Fragment>
  );
};

export default AthleteUserEntriesDetail;